import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { AuthProvider } from './contexts/AuthContext';
import { moduleRegistry } from '@em-cms/core';
import { blogModule } from '../../../modules/blog/src/index';
import { formsModule } from '../../../modules/forms/src/index';
import { productsModule } from '../../../modules/products/src/index';
import { projectsModule } from '../../../modules/projects/src/index';
import { contentModule } from '../../../modules/content/src/index';
import { storageModule } from '../../../modules/storage/src/index';
import { analyticsModule } from '../../../modules/analytics/src/index';
import { seoModule } from '../../../modules/seo/src/index';
import './index.css';

// Register all modules
moduleRegistry.register(blogModule);
moduleRegistry.register(formsModule);
moduleRegistry.register(productsModule);
moduleRegistry.register(projectsModule);
moduleRegistry.register(contentModule);
moduleRegistry.register(storageModule);
moduleRegistry.register(analyticsModule);
moduleRegistry.register(seoModule);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
